import { Card, Row, Col, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function QuickActionsCard({ pendingUsers }) {
  return (
    <Card className="dashboard-card border-0">
      <Card.Header className="bg-white border-bottom-0 pt-3 pb-2">
        <h6 className="mb-0 fw-semibold">
          <i className="bi bi-lightning-charge me-2 text-primary"></i>Quick Actions
        </h6>
      </Card.Header>
      <Card.Body>
        <Row className="g-2">
          <Col lg={3} md={6}>
            <Link to="/admin/users" className="btn btn-outline-warning w-100 d-flex align-items-center justify-content-center gap-2">
              <i className="bi bi-hourglass-split"></i>
              Review Pending
              {pendingUsers > 0 && <Badge bg="warning" text="dark" pill>{pendingUsers}</Badge>}
            </Link>
          </Col>
          <Col lg={3} md={6}>
            <Link to="/register" className="btn btn-outline-success w-100 d-flex align-items-center justify-content-center gap-2">
              <i className="bi bi-person-plus"></i>
              Register New Person
            </Link>
          </Col>
          <Col lg={3} md={6}>
            <Link to="/search" className="btn btn-outline-primary w-100 d-flex align-items-center justify-content-center gap-2">
              <i className="bi bi-search"></i>
              Search Records
            </Link>
          </Col>
          <Col lg={3} md={6}>
            <Link to="/analytics/select" className="btn btn-outline-info w-100 d-flex align-items-center justify-content-center gap-2">
              <i className="bi bi-bar-chart"></i>
              View Analytics
            </Link>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default QuickActionsCard;
